import { IRentDetail } from '../interfaces/iquote.interface'

export interface MonthlyRentBreakdown {
  rent: number
  accessories: number
  hasAccessories: boolean
  /** Renta + accesorios, sin IVA. Solo tiene sentido mostrarlo cuando hay accesorios. */
  subtotal: number
  iva: number
  total: number
}

/**
 * Desglose de la renta mensual tal como lo lee quien arma el contrato (F-012).
 *
 * `rent.amount` es SOLO la renta: los accesorios financiados vienen aparte en `rent.accessories`, y el
 * IVA del motor ya se calcula sobre la suma de los dos. Por eso el subtotal no viene del backend y hay
 * que derivarlo aquí; antes las pantallas rotulaban «Subtotal» a la renta sola y con accesorios no
 * cuadraba con el total. Se redondea al centavo porque la suma de dos montos con decimales en coma
 * flotante deja colas (p. ej. 0.1 + 0.2).
 *
 * No recalcula nada del motor: IVA y total se muestran tal cual llegan.
 */
export function monthlyRentBreakdown(rent: IRentDetail | null | undefined): MonthlyRentBreakdown {
  const amount = rent?.amount ?? 0
  const accessories = rent?.accessories ?? 0
  return {
    rent: amount,
    accessories,
    hasAccessories: accessories > 0,
    subtotal: Math.round((amount + accessories) * 100) / 100,
    iva: rent?.iva ?? 0,
    total: rent?.total ?? 0,
  }
}
